interface Opts {
  fill?: 'lastValue' | 'zero';
  withEnd?: boolean;
  withStart?: boolean;
}

const getNonNullValueFrom = (data: (number | null)[], i = 0) => {
  for (let j = i; j < data.length; j += 1) {
    if (data[j] !== null) {
      return data[j];
    }
  }

  return null;
};

export default (data: (null | number)[], opts: Opts = {}): (null | number)[] => {
  const { fill = 'lastValue', withEnd, withStart } = opts;

  const nextData: (null | number)[] = [];
  const firstValue = getNonNullValueFrom(data, 0);
  let lastValue: number | null = null;

  if (data.length < 2) return data;
  if (firstValue === null) return data;

  for (let i = 0; i < data.length; i += 1) {
    if (data[i] === null) {
      /** Start of the series */
      if (lastValue === null) {
        if (withStart) {
          nextData.push(fill === 'lastValue' ? firstValue : 0);
        } else {
          nextData.push(null);
        }

        /** Middle of the series */
      } else if (getNonNullValueFrom(data, i + 1) !== null) {
        nextData.push(fill === 'lastValue' ? lastValue : 0);

        /** End of the series */
      } else if (withEnd) {
        nextData.push(fill === 'lastValue' ? lastValue : 0);
      } else {
        nextData.push(null);
      }
    } else {
      lastValue = data[i];
      nextData.push(data[i]);
    }
  }

  return nextData;
};
